import { apiRequest } from "./apiClient";

const mapFromApi = (profile) => {
  if (!profile) return null;

  const prefs = profile.preferences || {};

  return {
    id: profile.id,
    username: prefs.username || "",
    company_name: prefs.companyName || "",
    contact_number: prefs.contactNumber || "",
    profile_completed: prefs.profile_completed === true,
  };
};

const mapToApi = (profileData) => ({
  bio: profileData.username || "",
  preferences: {
    username: profileData.username || "",
    companyName: profileData.companyName || "",
    contactNumber: profileData.contactNumber || "",
    profile_completed: true,
  },
});

export const profileService = {
  async getProfile() {
    const data = await apiRequest("/vitaflow/profile", {
      method: "GET",
    });

    return mapFromApi(data);
  },

  async createProfile(profileData) {
    const payload = mapToApi(profileData);
    const data = await apiRequest("/vitaflow/profile", {
      method: "POST",
      body: JSON.stringify(payload),
    });

    return mapFromApi(data);
  },

  async updateProfile(profileData) {
    const payload = mapToApi(profileData);
    const data = await apiRequest("/vitaflow/profile", {
      method: "PUT",
      body: JSON.stringify(payload),
    });

    return mapFromApi(data);
  },
};
